import React, { FC } from 'react';
import Pagination from 'antd/lib/pagination';
import './style.scss';
import Props from './typing';
import imgURL from 'lib/imgURL';
import { isCitiTheme } from 'lib/analyticsUtil';

const Index: FC<Props> = (props): JSX.Element => {
  const {
    currentPage,
    onPageChange,
    total,
    pageSize = 10,
    showSizeChanger = false,
    pageSizeOptions,
    onPageSizeChange,
    showPluralLogo,
  } = props;
  const isCiti = isCitiTheme();

  const handlePageChange = (page: number, selectedPageSize = pageSize) => {
    if (selectedPageSize !== pageSize && onPageSizeChange) {
      onPageSizeChange(selectedPageSize);
      return;
    }

    onPageChange?.(page, selectedPageSize);
  };

  return (
    <React.Fragment>
      <div className="pagination-section">
        <Pagination
          defaultCurrent={1}
          pageSize={pageSize}
          size="small"
          current={currentPage}
          total={total}
          onChange={handlePageChange}
          showSizeChanger={showSizeChanger}
          pageSizeOptions={pageSizeOptions}
        />
        {showPluralLogo && isCiti && (
          <div className='powered-by-plural'>
            <img src={imgURL['powered-pinelabs-online']} alt='powered by pinelabs online' />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Index;
